/* Match each rule to the longer visible text line, after fonts and layout settle. */
(() => {
  const start = () => {
    const blocks = Array.from(document.querySelectorAll('.main-slideshow [data-uso-rule]'));
    if (!blocks.length) return;
    let frame;
    const measure = () => {
      frame = null;
      blocks.forEach(block => {
        const heading = block.querySelector('h2');
        if (!heading) return;
        const left = heading.getBoundingClientRect().left;
        let width = 0;
        block.querySelectorAll('[data-uso-rule-text]').forEach(text => {
          Array.from(text.getClientRects()).forEach(rect => {
            if (rect.width > 0) width = Math.max(width, rect.right - left);
          });
        });
        if (width > 0) block.style.setProperty('--uso-rule-width', `${width.toFixed(2)}px`);
      });
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };
    schedule();
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      blocks.forEach(block => observer.observe(block));
    }
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('pageshow', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
